import {NavMenu}  from '../NavMenu';
import React, { useState, useContext, useEffect } from 'react';
import PageFooter from '../PageFooter';
import { Container } from 'reactstrap';
import { Outlet } from 'react-router-dom';
import { Offcanvas, OffcanvasHeader, OffcanvasBody } from 'reactstrap';
import { PageContextProvider, PageContext } from '../PageContext';
import { NotificationList } from '../NotificationList';
import { Drawer, DrawerContent, DrawerSelectEvent, Menu, MenuItem, MenuItemProps, MenuSelectEvent } from '@progress/kendo-react-layout';
import { UserContext } from '../UserContext';
import { useThemeSwitcher } from 'react-css-theme-switcher';
import { AdminHeader } from './AdminHeader';
import { Button, DropDownButton, SplitButton } from '@progress/kendo-react-buttons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faUser, faQuestionCircle, faBell, faMagnifyingGlass, faForward, faFileCirclePlus, faTrash, faShare, faGlobe, faQuestion, faBullhorn, faUsers} from '@fortawesome/free-solid-svg-icons';
import { userIcon, calendarDateIcon, gearIcon } from '@progress/kendo-svg-icons';

function AdminLayout () {

    const [showAdminNav, setShowAdminNav]=useState(false);
    const toggleNav=()=>setShowAdminNav(!showAdminNav);
    const pageContext = useContext(PageContext);
    const userContext = useContext(UserContext);
    
   
    const { switcher, themes, currentTheme, status } = useThemeSwitcher();


    const menuRender=(props:any)=>{
        console.log(props);
        switch (props.item.text){
            case "Users":
            case "User Manager":
                return(
                    <>
                    This is a test {props.item.text}
                    </>
                );    
            break;
        }
    }

    const menuSelect = (event: MenuSelectEvent) => {
        switch (event.item && event.item.text) {
            case "Users":
                window.location.href = "/Admin/Users";
                break;
            case "Publications":
                window.location.href = "/Admin/Pubs";
                break;
            case "Group Pubs":
                window.location.href = "/Admin/GroupPubs";
                break;
            case "Statuses":
                window.location.href = "/Admin/Statuses";
                break;
            case "Sub Statuses":
                window.location.href = "/Admin/SubStatuses";
                break;
            case "Ad Types/Sizes":
                window.location.href = "/Admin/Sizes";
                break;
            case "Modular Sizes":
                window.location.href = "/Admin/ModSizes";
                break;
            case "Modular Packages":
                window.location.href = "/Admin/Packages";
                break;
            case "Sites":
                window.location.href = "/Admin/Sites";
                break;
            case "Publication Deadlines":
                window.location.href = "/Admin/Deadlines";
                break;
            case "Holiday Deadlines":
                window.location.href = "/Admin/Holidays";
                break;
            case "Router":
                window.location.href = "/Admin/Router";
                break;
        }
    }

    useEffect(()=>{
        console.log(userContext?.user);
      },[])

    

    return (
        userContext?.user.username !== "" ? (
            <div>
                <title>Administrator - AdTracker:Online</title>
                <AdminHeader toggleNav={toggleNav}/>                
                <NotificationList></NotificationList>
                <Menu
                    className="p-3"
                    hoverOpenDelay={0}
                    hoverCloseDelay={200}
                    onSelect={menuSelect}
                >
                    <MenuItem text="User Manager" icon='user'>
                        <MenuItem text="Users" />
                        {/* <MenuItem text="Orphan Associations" />
                        <MenuItem text="Assign Sales Reps" />
                        <MenuItem text="User Queries" />
                        <MenuItem text="User Attributes" />                     */}
                    </MenuItem>
                    <MenuItem text="Configuration" icon="gear">
                        <MenuItem text="Publications" />
                        <MenuItem text="Group Pubs" />
                        <MenuItem text="Statuses" />
                        <MenuItem text="Sub Statuses" />
                        <MenuItem text="Ad Types/Sizes" />   
                        <MenuItem text="Modular Sizes" />
                        <MenuItem text="Modular Packages" />
                        <MenuItem text="Sites" />      
                    </MenuItem>
                    <MenuItem text="Deadlines" icon="calendar">
                        <MenuItem text="Publication Deadlines" />
                        <MenuItem text="Holiday Deadlines" />
                    </MenuItem>
                    <MenuItem text="Router" icon="share" />
                    <MenuItem text="Business System" icon='download'/>
                    <MenuItem text="Fresh Desk" icon="headset">
                        <MenuItem text="Account Blacklist" />
                        <MenuItem text="Sales Rep Blacklist" />
                    </MenuItem>
                    <MenuItem text="Change Log" icon="track-changes"/>

                </Menu>
                <Container fluid tag="main" className='atolMain'>
                        <Outlet />
                </Container>           
                <PageFooter />
            </div>
            ) : (
                <div>
                <NavMenu toggleSearch={()=>toggleNav()}  />
                <Container fluid tag="main" className='atolMain'>
                <center>
                <h3>Sorry. You are not authorized to access this resource.</h3>
                <a href='/Login'>Login</a>
                </center>
                </Container>
                <PageFooter />
                </div>
            )
        );
}

export default AdminLayout;